<template>
  <div>
    <div class="contents-inner">
      <div class="feature-block">
        <p class="hd-type-0n2">
          <span>働く環境の特徴</span>
        </p>
        <div
          class="environment"
          :style="`background: url(${userOfferImageUrlForSp}/environment_bg.png) no-repeat top;`"
        >
          <ul>
            <li
              v-for="environment in requirements.features.environments"
              :key="`environment-star-${environment.id}`"
              :style="`background: url(${userOfferImageUrlForSp}/feature_star_img.png) no-repeat;`"
              :class="`enviro-star-0${environment.name}`"
              :data-test="`environment-star-${environment.id}`"
            />
          </ul>
        </div>
      </div>
    </div>

    <div class="contents-inner">
      <div class="feature-block">
        <p class="hd-type-0n2">
          <span>この仕事の特徴</span>
        </p>
        <div
          class="work-feature"
          :style="`background: url(${userOfferImageUrlForSp}/work_feature_bg.png) no-repeat top;`"
        >
          <ul>
            <li
              v-for="work in requirements.features.work"
              :key="`work-feature-bar-${work.id}`"
              class="logout"
              :data-test="`work-feature-bar-${work.id}`"
            >
              <span :class="`work-feature-bar-0${work.name}`" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'

export default {
  mixins: [jobPreviewCommon],
  props: {
    requirements: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
